import { Skeleton } from "@/components/ui/skeleton"

export const EventDetailSkeleton = () => {
    return (
        <>
            {/* Hero Banner Skeleton */}
            <div className="relative w-full h-[300px] sm:h-[437px] lg:max-h-[362px] overflow-hidden bg-gray-200 animate-pulse">
                <div className="absolute inset-0 bg-gray-300" />
                <div className="container relative z-10 h-full flex items-center justify-center lg:justify-start">
                    <div className="lg:px-[5.625rem] w-full">
                        <div className="flex flex-col gap-0 pt-12 px-8 pb-0 sm:pt-0 sm:px-0 lg:gap-4">
                            {/* Breadcrumb Skeleton */}
                            <div className="flex flex-row items-center justify-center sm:justify-start gap-2">
                                <Skeleton className="h-4 w-20 rounded" />
                                <span className="text-gray-400">-</span>
                                <Skeleton className="h-4 w-16 rounded" />
                            </div>
                            {/* Title Skeleton */}
                            <Skeleton className="h-8 sm:h-10 lg:h-16 w-3/4 mx-auto lg:mx-0 mt-4 lg:mt-0 rounded" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Content Skeleton */}
            <div className="w-full max-w-[1304px] mx-auto sm:px-2 px-4 sm:pt-[50px] pt-4 sm:pb-10 pb-8">
                <div className="flex sm:flex-row flex-col sm:gap-[80px] gap-4">
                    {/* Main Content Skeleton */}
                    <div className="flex flex-col gap-4 sm:w-[59.4%] w-full">
                        <div className="flex gap-3 w-full items-center">
                            <Skeleton className="h-6 w-16 rounded" />
                            <div className="border-b-[1px] border-[#CCCCCC] w-full"></div>
                        </div>
                        <div className="w-full space-y-3">
                            <Skeleton className="h-4 w-full rounded" />
                            <Skeleton className="h-4 w-full rounded" />
                            <Skeleton className="h-4 w-5/6 rounded" />
                            <Skeleton className="h-4 w-4/5 rounded" />
                        </div>
                        <div className="flex gap-4 items-center pt-2">
                            <Skeleton className="h-5 w-16 rounded" />
                            <Skeleton className="h-8 w-8 rounded-full" />
                            <Skeleton className="h-8 w-8 rounded-full" />
                        </div>
                    </div>

                    {/* Sidebar Skeleton */}
                    <div className="flex flex-col gap-4 sm:w-[38.6%] w-full">
                        {Array.from({ length: 4 }).map((_, index) => (
                            <div key={index} className="flex flex-col gap-2">
                                <div className="flex gap-3 w-full items-center">
                                    <Skeleton className="h-6 w-20 rounded" />
                                    <div className="border-b-[1px] border-[#CCCCCC] w-full"></div>
                                </div>
                                <Skeleton className="h-6 w-32 rounded" />
                            </div>
                        ))}
                        <Skeleton className="h-4 w-full rounded mt-2" />
                        <div className="flex gap-0 w-full">
                            <Skeleton className="flex-1 h-[42px] rounded rounded-r-none" />
                            <Skeleton className="w-[83.5px] h-[42px] rounded rounded-l-none" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

